// import required modules
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import { useLocation } from 'react-router-dom';

import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import useLocale from 'hooks/useLocale';

import * as S from './Layout.styled';

const RegisterSlide = ({ isReferral, isSlideShow, setIsSlideShow }) => {
	const { pathname } = useLocation();

	const message =
		pathname.split('/')[1] === 'register'
			? 'signUp'
			: pathname.split('/')[1] === 'login'
				? 'signIn'
				: 'forgotPassword';

	const { LanguageCode } = useLocale();

	const firstSvg =
		LanguageCode === 'arabicValue'
			? 'https://storage.googleapis.com/tryoto-public/referral/slider/first-ar.svg'
			: 'https://storage.googleapis.com/tryoto-public/referral/slider/first.svg';
	const secondSvg =
		LanguageCode === 'arabicValue'
			? 'https://storage.googleapis.com/tryoto-public/referral/slider/second-ar.svg'
			: 'https://storage.googleapis.com/tryoto-public/referral/slider/second.svg';

	return (
		<S.SlideContainer isSlideShow={isSlideShow}>
			<S.MobileLogo>
				<Image
					width={'6.5rem'}
					height={'6.5rem'}
					url="https://storage.googleapis.com/tryoto-public/public/assets/images/otoLogo.png"
				/>
			</S.MobileLogo>

			<Swiper
				key={document.body.dir}
				dir={document.body.dir}
				spaceBetween={30}
				centeredSlides={true}
				autoplay={{
					delay: 3000,
					disableOnInteraction: false
				}}
				pagination={{
					clickable: false
				}}
				modules={[Autoplay, Pagination]}
				className="swiper-container">
				<SwiperSlide>
					<Image url={firstSvg} height="unset" />
					<div>
						<Typography className="title" fontWeight="700" color="var(--white)" align="center" noWrap>
							registerSlide1Header
						</Typography>
						<Typography className="subtitle" fontWeight="500" color="#E3E6F6" align="center" noWrap>
							registerSlide1Description
						</Typography>
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<Image url={secondSvg} height="unset" />
					<div>
						<Typography className="title" fontWeight="700" color="var(--white)" align="center" noWrap>
							registerSlide2Header
						</Typography>
						<Typography className="subtitle" fontWeight="500" color="#E3E6F6" align="center" noWrap>
							registerSlide2Description
						</Typography>
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<Image
						height="unset"
						url={'https://storage.googleapis.com/tryoto-public/referral/slider/third.svg'}
					/>
					<div>
						<Typography className="title" fontWeight="700" color="var(--white)" align="center" noWrap>
							registerSlide3Header
						</Typography>
						<Typography className="subtitle" fontWeight="500" color="#E3E6F6" align="center" noWrap>
							registerSlide3Description
						</Typography>
					</div>
				</SwiperSlide>
			</Swiper>

			<S.MobileRegisterPageButton
				variant="black"
				size="xx-large"
				label={isReferral ? 'registerSlideReferralButton' : message}
				onClick={() => setIsSlideShow(false)}
				fullWidth
			/>
		</S.SlideContainer>
	);
};

export default RegisterSlide;
